import { CategoryTypeEnum } from '@repo/common/enums';

export const isVisioStoreCategory = (category?: any): boolean =>
  category === CategoryTypeEnum.VISIO_STORE;
